import { Injectable } from '@angular/core';
import { RestClientService } from '../../rest/rest-client.service';
import { DossierDTO } from '../model/scoring/dossier-dto';
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
  })
  export class ScoringService{
  
    constructor(
        private http: HttpClient, private _restClientService : RestClientService) 
    {}

    findAllDossierByRequest(requestId) {
        return this._restClientService.load<DossierDTO[]>('scoring/find-all-dossier-by-request?requestid='+requestId);
    }
    
    getPdfByDossierId(dossierid: string): Observable<Blob> {
        
        const downloadUrl = environment.BACKEND_RACINE_URL+`scoring/rapport-global-by-dossier?dossierid=${dossierid}`;
  
        const options = {
          responseType: 'blob' as 'json',
        };
        
        return this.http.get<any>(downloadUrl, options);
    }
  
}